import React, { useState } from 'react'
import { MuiGrid, MuiTypography } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme';
import en from 'date-fns/locale/en-US';
import format from 'date-fns/format';
import { startOfWeek } from "date-fns";
import lodash from 'lodash';
import TimeHeaderComponent from './TimeHeaderComponent'
import addDays from 'date-fns/addDays';
import IndividualTimeTableGrid from './IndividualTimeTableGrid';
import CalendarGrid from './CalendarGrid'

export default function IndividualTimeTableForForTeacher(props) {
  const i18n = props.i18n
  let header = props.header
  let timeTableForTeacher = props.timeTableForTeacher;
  return (
    <MuiGrid container>

      <CalendarGrid {...props} title={i18n.weeklyTimeTable.availableTeachers} index={0}
        noOfTTShowIndex={0}
      >
        <IndividualTimeTableGrid {...props} header={header} classItem={props.availableTeachersList} availableTeachers={true} cardIndex={0} noOfTTShowIndex={0} />
      </CalendarGrid>
      {timeTableForTeacher != undefined && timeTableForTeacher.map((teacher, index2) => (
        <CalendarGrid {...props}
          title={teacher.firstName + " " + teacher.lastName + ' ( ' + teacher.id + ' ) ' + (teacher.groupName != undefined ? ' ( ' +  i18n.weeklyTimeTable.groupTeacherFor  + ' ' + teacher.groupName.toUpperCase() + ' )' : '')}
          index={index2}
          noOfTTShowIndex={props.noOfTimeTableForTeacherToShowIndex}
        >
          <IndividualTimeTableGrid {...props} header={header} classItem={teacher.days} availableTeachers={false} cardIndex={index2} noOfTTShowIndex={props.noOfTimeTableForTeacherToShowIndex} />
        </CalendarGrid>
      ))}
    </MuiGrid>
  )
}